import { Action, createReducer, on } from '@ngrx/store';

import * as EmailSearchActions from './email-search.actions';
import { User } from '@mode/algolia/contract';

export const EMAIL_SUBSCRIBER_FEATURE_KEY = 'emailSearch';

export interface EmailSearchState {
  searchResults: User[];
  loaded: boolean;
  error: string | null;
}

export const initialEmailSearchState: EmailSearchState = {
  searchResults: [],
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialEmailSearchState,
  on(EmailSearchActions.searchEmail, (state) => ({ ...state, loaded: false, error: null })),
  on(EmailSearchActions.searchEmailSuccess, (state, { searchResults }) => ({ ...state, searchResults, loaded: true })),
  on(EmailSearchActions.searchEmailFailure, (state, { error }) => ({ ...state, error, loaded: true }))
);

export function emailSearchReducer(state: EmailSearchState | undefined, action: Action) {
  return reducer(state, action);
}
